import { IRouteMatch } from './IRouteMatch';
import { normalisePath } from './normalisePath';
import { toParams } from './toParams';

export function matchRoute(
  path: string,
  routeExp: RegExp): IRouteMatch | null {

  if (path == null || path[0] !== '/')
    throw new Error('path is invalid, should start with "/"');

  path = normalisePath(path);

  const match = routeExp.exec(path) as any;
  routeExp.lastIndex = 0;

  if (match) {
    const { __search, ...params } = match.groups;

    return {
      params: Object.keys(params).length ? params : null,
      search: toParams(__search)
    };
  }

  return null;
}
